// U32b — «Chi tiết clip» của bước gộp Prompt & Video: ngăn bên phải chứa bước Video đầy đủ (phiếu AI chấm clip, hộp ghi lý do khi chọn bản, xoá bản, video tham chiếu).
// Dữ liệu phiếu do CHÍNH ngăn này sở hữu (`useStepReviews`, chỉ nạp khi ngăn mở). Việc Gen vẫn đi qua runner ở cột phải (workflowManaged).
import React, { useState } from 'react';
import { Drawer } from 'antd';
import type { EventPlan, FilmEvent } from '../../types/film';
import type { WorkflowStatus } from '../../types/filmWorkflow';
import WorkflowVideoStep from './WorkflowVideoStep';
import WorkflowStepReviewCard from './WorkflowStepReviewCard';
import { CL_REVIEW } from './stepReviewPolicy';
import { useStepReviews } from './useStepReviews';
import { clipBoardOf, clipLabelOf, clipOrdersOf, effectiveFocusClipId } from './clipReviewPolicy';

interface Props {
  open: boolean;
  onClose: () => void;
  status: WorkflowStatus;
  planId: string;
  storyId: string;
  eventId: string;
  order: number;
  ev: FilmEvent | null;
  detail: EventPlan | null;
  onActionDone: () => void;
}

const Body: React.FC<Omit<Props, 'open' | 'onClose'>> = ({ status, planId, storyId, eventId, ev, detail, onActionDone }) => {
  const ctl = useStepReviews({ planId, eventId, onActionDone, enabled: true });
  const [focus, setFocus] = useState<string | null>(null);
  if (!ev) return <p className="muted">Chưa tải được dữ liệu chi tiết của video này — đóng ngăn rồi thử lại.</p>;
  const clips = ev.clips ?? [];
  const focusClipId = effectiveFocusClipId(clips, ev.selectedClipId, focus);
  const order = focusClipId ? clipOrdersOf(clips, clipBoardOf(ctl.view, eventId))[focusClipId] : undefined;
  const stepState = status.events.find((e) => e.eventId === eventId)?.steps.VIDEO ?? 'NOT_READY';
  return (
    <div className="wf" style={{ padding: 0, background: 'transparent' }}>
      <WorkflowStepReviewCard key={eventId} planId={planId} eventId={eventId} stepKey={CL_REVIEW} jobs={status.jobs} onActionDone={onActionDone}
        candidateClipId={focusClipId} clipLabel={order ? clipLabelOf(order) : undefined} controller={ctl} />
      <WorkflowVideoStep key={eventId} planId={planId} storyId={storyId} stepState={stepState} jobs={status.jobs} failures={status.failures} onActionDone={onActionDone}
        onJobsRefresh={async () => { onActionDone(); return { jobs: status.jobs, failures: status.failures }; }}
        clipReviews={{ ctl, focusClipId, onFocusClip: setFocus }} eventId={eventId} ev={ev} detail={detail} workflowManaged />
    </div>
  );
};

const WorkflowClipDetailDrawer: React.FC<Props> = ({ open, onClose, order, ...rest }) => (
  <Drawer title={`Chi tiết clip · Video ${order}`} open={open} onClose={onClose} width={720} destroyOnClose data-testid="wf-pv-drawer">
    <Body order={order} {...rest} />
  </Drawer>
);

export default WorkflowClipDetailDrawer;
